import { UserAgent, PostMessagePayload } from '@/types';

const checkUserAgent = (userAgent: UserAgent) =>
  window.navigator.userAgent.indexOf(userAgent) !== -1;

const postMessage = (payload: PostMessagePayload) => {
  window.postMessage(JSON.stringify(payload), '*');
};

export { checkUserAgent, postMessage };
